export default {
    methods: {
        // todo: get values, manualvalues, addresses directly from services
        getConfigurationPayload: function ( values, manualValues, addresses, files, productType = window.FlyerlineConfig.productType ) {
            return {
                configuration: JSON.stringify({
                    selectedValues: {...values},
                    manualValues: {...manualValues}
                }),
                addresses: JSON.stringify(addresses),
                files: JSON.stringify(files),
                productType: productType
            };
        },
        getConfigurationUrlParams: function (configuratorService, values, manualValues, addresses, files, productType = window.FlyerlineConfig.productType) {
            let params = 'jsonConf=' + JSON.stringify(configuratorService.lightweightConf())
            return params
        }

    }
}